import { Component } from '@angular/core';

import { AbstractComponent } from '../abstract-component';

@Component({
    selector: 'app-pagina-no-encontrada',
    imports: [],
    templateUrl: './pagina-no-encontrada.component.html',
    styleUrl: './pagina-no-encontrada.component.css'
})
export class PaginaNoEncontradaComponent extends AbstractComponent{

}
